import React from 'react';

function App() {
  return (
    <div>
      <h1>AI Search Engine</h1>
      <p>Coming soon...</p>
    </div>
  );
}

export default App;
